import { stateOptions } from "@/config";

export default [
    {
        title: 'Requestor Information',
        fields: [
            {
                label: 'Requestor Name',
                name: 'requestor_name',
                type: 'text',
                span: 12,
                required: true,
                placeholder: 'First Name Last Name',
            },
            {
                label: 'Requestor Email',
                name: 'requestor_email',
                type: 'email',
                span: 12,
                required: true,
                placeholder: 'example@gmail.com',
            },
            {
                label: 'Phone',
                name: 'requestor_phone',
                type: 'otp',
                span: 12,
                length: 10,
                required: true,
                className: 'w-full',
            },
            {
                label: 'Fax',
                name: 'requestor_fax',
                type: 'otp',
                length: 10,
                span: 12,
                required: true,
                className: 'w-full',
                placeholder: 'Please enter fax number',
            }
        ]
    },
    {
        title: 'Patient Information',
        fields: [
            {
                label: 'Patient First Name',
                name: 'patient_first_name',
                type: 'text',
                span: 12,
                required: true,
            },
            {
                label: 'Patient Last Name',
                name: 'patient_last_name',
                type: 'text',
                span: 12,
                required: true,
            },
            {
                label: 'Date of Birth',
                name: 'patient_dob',
                type: 'datePicker',
                format: 'MM-DD-YYYY',
                dateValidation: {
                    disallowFuture: true,
                    minAge: 365,  // Must be at least 365 days old
                    futureMessage: 'Date of birth cannot be in the future',
                    minAgeMessage: 'Patient must be at least 1 year old'
                },
                span: 12,
                required: true,
                style: {
                    width: '100%',
                },
                placeholder: 'MM-DD-YYYY',
            },
            {
                label: 'Gender',
                name: 'patient_gender',
                type: 'select',
                span: 12,
                required: true,
                placeholder: 'Select Gender',
                options: [
                    { label: 'Male', value: "Male" },
                    { label: 'Female', value: "Female" },
                ],
            },
            {
                label: 'Address',
                name: 'patient_address',
                type: 'text',
                placeholder: 'Please enter address',
                span: 24,
                required: true,
            },
            {
                label: 'City',
                name: 'patient_city',
                type: 'text',
                span: 6,
                required: true,
                placeholder: 'Please enter patient city'
            },
            {
                label: 'State',
                name: 'patient_state',
                type: 'select',
                span: 6,
                required: true,
                options: stateOptions
            },
            {
                label: 'Zip',
                name: 'patient_zip',
                type: 'otp',
                length: 5,
                span: 6,
                required: true,
            },
            {
                label: 'Phone',
                name: 'patient_phone',
                type: 'otp',
                length: 10,
                span: 6,
                required: true,
            }
        ]
    },
    {
        title: 'Payer Information',
        fields: [
            {
                title: 'PRIMARY INSURANCE',
                type: 'typography',
                span: 24,
                className: 'font-bold -mb-4',
            },
            {
                label: 'Participating Provider',
                name: 'insurance_primary_provider',
                type: 'radio-group',
                span: 6,
                required: true,
                options: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                    { label: 'Unknown', value: 'unknown' },
                ],
            },
            {
                label: 'Primary Insurance Name',
                name: 'primary_insurance_name',
                type: 'text',
                span: 6,
                required: true,
            },
            {
                label: 'Payer Phone',
                name: 'insurance_primary_payer_phone',
                type: 'otp',
                length: 10,
                span: 12,
                required: true,
            },
            {
                label: 'Policy Number',
                name: 'insurance_primary_policy_number',
                type: 'text',
                span: 12,
                required: true,
                placeholder: 'Please enter policy number'
            },
            {
                label: 'Group Number',
                name: 'insurance_primary_group_number',
                type: 'text',
                span: 12,
                required: true,
                placeholder: 'Please enter group number'
            },
            {
                label: 'Policy Holder Name',
                name: 'insurance_primary_policy_holder_name',
                type: 'text',
                span: 12,
                required: true,
                placeholder: 'Please enter policy holder name'
            },
            {
                label: 'Policy Holder Date of Birth (primary)',
                name: 'primary_policy_holder_dob',
                type: 'datePicker',
                format: 'MM-DD-YYYY',
                span: 6,
                placeholder: 'MM-DD-YYYY',
                style: {
                    width: '100%',
                }
            },
            {
                label: 'Insurance Card',
                name: 'insurance_card',
                type: 'upload',
                span: 6,
                accept: '.pdf',
            },
            {
                title: 'SECONDARY INSURANCE',
                type: 'typography',
                span: 24,
                className: 'font-bold -mb-4',
            },
            {
                label: 'Participating Provider',
                name: 'insurance_secondary_provider',
                type: 'radio-group',
                span: 6,
                options: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                    { label: 'Unknown', value: 'unknown' },
                ],
            },
            {
                label: 'Secondary Insurance Name',
                name: 'secondary_insurance_name',
                type: 'text',
                span: 6,
            },
            {
                label: 'Payer Phone',
                name: 'insurance_secondary_payer_phone',
                type: 'otp',
                length: 10,
                span: 12,
                placeholder: 'Please enter payer phone' 
            },
            {
                label: 'Policy Number',
                name: 'insurance_secondary_policy_number',
                type: 'text',
                span: 12,
                placeholder: 'Please enter policy number'
            },
            {
                label: 'Group Number',
                name: 'insurance_secondary_group_number',
                type: 'text',
                span: 12,
                placeholder: 'Please enter group number'
            },
            {
                label: 'Policy Holder Name',
                name: 'insurance_secondary_policy_holder_name',
                type: 'text',
                span: 12,
                placeholder: 'Please enter policy holder name'
            },
            {
                label: 'Policy Holder Date of Birth (secondary)',
                name: 'secondary_policy_holder_dob',
                type: 'datePicker',
                format: 'MM-DD-YYYY',
                span: 6,
                placeholder: 'MM-DD-YYYY',
                style: {
                    width: '100%',
                },
            },
        ],
    },
    {
        title: 'Physician and Facility Information',
        fields: [
            {
                label: 'Physician Name',
                name: 'physician_name',
                type: 'text',
                span: 12,
                required: true,
                placeholder: 'Please enter physician name'
            },
            {
                label: 'Specialty',
                name: 'physician_specialty',
                type: 'text',
                span: 12,
                required: true,
                placeholder: 'Please enter physician specialty'
            },
            {
                label: 'Physician NPI',
                name: 'physician_npi',
                type: 'text',
                span: 8,
                required: true,
                placeholder: 'Please enter physician NPI'
            },
            {
                label: 'Physician Tax ID',
                name: 'physician_fax',
                type: 'text',
                span: 8,
                required: true,
                placeholder: 'Please enter physician tax id'
            },
            {
                label: 'Medicaid Provider',
                name: 'physician_medicaid_provider',
                type: 'text',
                span: 8,
                required: true,
                placeholder: 'Please enter physician medicaid provider'
            },
            {
                label: 'Facility Name',
                name: 'facility_name',
                type: 'text',
                span: 24,
                required: true,
                placeholder: 'Please enter facility name'
            },
            {
                label: 'Address',
                name: 'facility_address',
                type: 'text',
                span: 24,
                required: true,
                placeholder: 'Please enter facility address'
            },
            {
                label: 'City',
                name: 'facility_city',
                type: 'text',
                span: 8,
                required: true,
                placeholder: 'Please enter facility city'
            },
            {
                label: 'State',
                name: 'facility_state',
                type: 'select',
                span: 8,
                required: true,
                options: stateOptions
            },
            {
                label: 'Zip',
                name: 'facility_zip',
                type: 'otp',
                length: 5,
                span: 8,
                required: true,
                placeholder: 'Please enter facility zip'
            },
            {
                label: 'Facility NPI',
                name: 'facility_npi',
                type: 'text',
                span: 8,
                required: true,
                placeholder: 'Please enter facility NPI'
            },
            {
                label: 'Facility Tax ID',
                name: 'facility_tax_id',
                type: 'text',
                span: 8,
                required: true,
                placeholder: 'Please enter facility tax id'
            },
            {
                label: 'Medicaid Provider',
                name: 'facility_medicaid_provider',
                type: 'text',
                span: 8,
                required: true,
                placeholder: 'Please enter facility medicaid provider'
            },
        ]
    },
    {
        title: 'Prescription Information',
        fields: [
            {
                label: 'Product Name',
                type: 'radio-group',
                name: 'program_id',
                span: 24,
                required: true,
                options: [
                    // {
                    //     label: 'NUWIQ (Antihemophilic Factor [Recombinant])',
                    //     value: 12,
                    // },
                    {
                        label: 'wilate (von Willebrand Factor/Coagulation Factor VIII Complex [Human])',
                        value: 21,
                    },
                ],
            },
            {
                label: 'ICD-10-CM Code(s)',
                name: 'prescription_icd10_code',
                type: 'text',
                span: 24,
                required: true,
                placeholder: 'Please enter ICD-10-CM code'
            },
            {
                label: 'Patient Site of Care',
                name: 'prescription_patient_site_of_care',
                type: 'radio-group',
                span: 24,
                required: true,
                options: [
                    { label: 'Hospital Inpatient', value: 'hospital_inpatient' },
                    { label: 'Hospital Outpatient', value: 'hospital_outpatient' },
                    { label: 'Physician Office', value: 'physician_office' },
                    { label: 'Home Infusion', value: 'home_infusion' },
                    {
                        label: 'Other',
                        value: 'other',
                        hasInput: true,
                        inputProps: {
                            name: 'other_site_of_care_specify',
                            placeholder: '(please specify)',
                        },
                    },
                ],
            },
            {
                label: 'Dose',
                name: 'prescription_dose',
                type: 'text',
                span: 12,
                required: true,
                placeholder: 'Please enter dose'
            },
            {
                label: 'Buy and Bill',
                name: 'prescription_buy_and_bill',
                type: 'radio-group',
                span: 12,
                required: true,
                options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                ],
            },
            {
                label: 'Directions',
                name: 'prescription_directions',
                type: 'textarea',
                span: 24,
                required: true,
                placeholder: 'Please enter directions'
            },
        ],
    },
    {
        title: 'Authorization for Release',
        fields: [
            {
                title: 'Healthcare Provider Signature (Required)',
                content: 'By signing below, I certify that I have obtained a valid authorization from the patient listed on this form, permitting me to release the patient\'s protected health information to Factor My Way, Octapharma, and/or to its contractors as necessary to obtain insurance coverage and payment information regarding NUWIQ® or wilate®.',
                type: 'typography',
                span: 24,
                className: 'text-sm',
            },
            {
                label: 'Signature of Qualified Healthcare Professional',
                name: 'licensed_prescriber_signature',
                type: 'text',
                span: 18,
                required: true,
                placeholder: 'Please enter'
            },
            {
                label: 'Date',
                name: 'licensed_prescriber_signature_date',
                type: 'datePicker',
                disabled: true,
                style: {
                    width: '100%',
                },
                span: 6,
            },
            // {
            //     title: 'Patient Signature (Optional)',
            //     content: 'By signing this authorization, I, the patient, authorize my healthcare provider to use and/or disclose protected health information (PHI) related to NUWIQ® or wilate® from my health records and insurance information to Factor My Way, Octapharma, and/or to its contractors as necessary to obtain insurance coverage and payment information. I understand that the information I authorize a person or entity to disclose may be shared with other people or entities and will no longer be protected by federal privacy regulations. I understand that if I choose to revoke this authorization, I must do so in writing to my healthcare provider.',
            //     type: 'typography',
            //     span: 24,
            //     className: 'text-sm',
            // },
            // {
            //     label: 'Signature of Patient or Guardian',
            //     name: 'patient_signature',
            //     type: 'text',
            //     disabled: true,
            //     span: 18,
            //     placeholder: 'Please sign on the downloaded PDF'
            // },
            // {
            //     label: 'Date',
            //     name: 'patient_signature_date',
            //     type: 'datePicker',
            //     disabled: true,
            //     style: {
            //         width: '100%',
            //     },
            //     span: 6,
            // },
            {
                content: 'Disclaimer: This resource provides information from a complex and evolving medical coding system. The treating physician is solely responsible for diagnosis coding and determination of the appropriate ICD-10-CM codes that describe the patient’s condition and are supported by the medical record. All codes listed in this guide are for informational purposes and are not an exhaustive list. The CPT, HCPCS, and ICD-10-CM codes provided are based on AMA or CMS guidelines. The billing party is solely responsible for coding of services (eg, CPT coding). Because government and other third-party payer coding requirements change periodically, please verify current coding requirements directly with the payer being billed.',
                type: 'typography',
                span: 24,
                className: 'text-sm',
            },
            {
                content: 'Confidentiality Notice: This facsimile transmission may contain confidential or legally privileged information that is intended only for the individual or entity named on this transmission sheet. If you are not the intended recipient, you are notified that any disclosure, copying, distribution, or reliance upon the contents of this facsimile is strictly prohibited. If you have received this facsimile in error, please notify us immediately by telephone so that we can arrange for the return of the transmitted materials to us at no cost to you.',
                type: 'typography',
                span: 24,
                className: 'text-sm',
            },
            // {
            //     label: 'Signed PDF',
            //     name: 'signed_pdf_file',
            //     type: 'upload',
            //     span: 24,
            //     required: true,
            //     accept: '.pdf',
            // },
        ],
    },
]